module.exports = __webpack_public_path__ + "c298a42bd27fa9e6cb3e0a02c26aec89.jpg";